import * as Mui from "@mui/material";
import { Route, Routes } from "react-router";
import VehicleExitSearch from "../component/vehicle-exit/VehicleExitSearch";
import VehicleExitStatus from "../component/vehicle-exit/VehicleExitStatus";
import VehicleExitConfirm from "../component/vehicle-exit/VehicleExitConfirm";
import { GenericTitleHeader } from "../component/common/GenericTitleHeader";
import useOperationTranslation from "../hooks/useOperationTranslation";
import SectionHeader from "../../../util/component/SectionHeader";
import React from "react";

export interface IVehicleExitState {
  tenant:string;
  id: number;
  plate: string;
  modelType: string;
  referenceLocation: string;
  from: string;
}

const VehicleExitPage = () => {
  const t = useOperationTranslation();
  return (
    <Mui.Box>
        <SectionHeader
            title={t("vehicleExit.search.titleBlue") + " " + t("vehicleExit.search.titleViolet")}
        />
      <Routes>
        <Route index={true} element={<VehicleExitSearch />} />
        <Route path="/status" element={<VehicleExitStatus />} />
        <Route path="/confirm" element={<VehicleExitConfirm />} />
      </Routes>
    </Mui.Box>
  );
};

export default VehicleExitPage;
